import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Icon } from 'legacy-packages/ft-cb';

const MetaDataNodeView = ({
  node,
  nodes,
  isFullText,
  iconSize,
  iconName,
  showIcon,
  classNamePrefix,
  nodeLevel,
}) => (
  <li key={node.tag_id}>
    <div className={`${classNamePrefix}ItemMetadata__treenode__level__label`}>
      {showIcon && <Icon name={iconName} size={iconSize} />}
      {isFullText ? (
        <span dangerouslySetInnerHTML={{ __html: node.description }} />
      ) : (
        <span>{node.title}</span>
      )}
    </div>
    <ul
      className={classNames(`${classNamePrefix}ItemMetadata__treenode__level`, {
        ItemMetadata_nested_level: nodeLevel > 0,
      })}
      key={`${node.tag_id}_sublist`}
    >
      {nodes}
    </ul>
  </li>
);

MetaDataNodeView.propTypes = {
  node: PropTypes.object.isRequired,
  nodes: PropTypes.array.isRequired,
  isFullText: PropTypes.bool.isRequired,
  iconSize: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  showIcon: PropTypes.bool.isRequired,
  classNamePrefix: PropTypes.string,
  nodeLevel: PropTypes.number,
};

MetaDataNodeView.defaultProps = {
  classNamePrefix: '',
  nodeLevel: 0,
};

export default MetaDataNodeView;
